export function maskLead(value: string, trailLength = 5) {
  return `XXXX-${value.slice(-trailLength)}`;
}
